import React from "react";
import { useHistory } from "react-router-dom";
import MdArrowBack from "react-ionicons/lib/MdArrowBack";

const BackButton = () => {
  let history = useHistory();
  return (
    <button className="flex" onClick={() => history.goBack()}>
      <MdArrowBack style={{ width: "16px" }} className="mr-1"></MdArrowBack>
      <div className="text-sm font-medium m-0">Atrás</div>
    </button>
  );
};

export default BackButton;
